// @flow

import { createContext } from 'react'

export const UserContext: any = createContext()

export class UserContextProps {
  userId: string
  role: string

  constructor(userId: string, role: string) {
    if (!isValidRole(role)) {
      const error = new Error(`Invalid role: ${role}.`)
      window.newrelic.noticeError(error)
    }

    this.userId = userId
    this.role = role
  }

  updateProfilePath(): string {
    const path = {
      customer: '/api/v4/bc/profile',
      billing_agent: `/agent/bc/profile/${this.userId}`,
    }
    return path[this.role]
  }

  createFacilityPath(): string {
    const path = {
      customer: '/api/v4/bc/facilities/private',
      billing_agent: `/agent/bc/facilities/private/${this.userId}`,
    }
    return path[this.role]
  }

  deleteFacilityPath(facilityId: string): string {
    const path = {
      customer: `/api/v4/bc/facilities/private/${facilityId}`,
      billing_agent: `/agent/bc/facilities/private/${this.userId}/${facilityId}`,
    }
    return path[this.role]
  }
}

const AVAILABLE_ROLES = ['customer', 'billing_agent']
function isValidRole(role: string): boolean {
  return AVAILABLE_ROLES.includes(role)
}
